module.exports = __webpack_public_path__ + "assets/images/school-header.svg?v=f38e4eef";